module.exports = __webpack_public_path__ + "img/cv_app_grafika_new.1b80e6af.png";